import React from "react";

// Define props interface
interface ImageBoxProps {
  headerText: string;
  paragraphText: string;
  imageSrc: string; // Imported image for background
  overlayColor?: string; // Optional color for the overlay
  textColor?: string; // Optional text color
  isMobile: boolean;
}

const ImageBox: React.FC<ImageBoxProps> = ({
  headerText,
  paragraphText,
  imageSrc,
  overlayColor = "rgba(0, 0, 0, 0.6)", // Default to a semi-transparent black overlay
  textColor = "#FFFFFF", // Default text color to white
  isMobile,
}) => {
  return (
    <div
      className="relative  mx-auto  p-6 overflow-hidden rounded"
      style={{
        backgroundImage: `url(${imageSrc})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay for darkening the background image */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: overlayColor }}
      ></div>

      {/* Content Section */}
      <div
        className={
          (isMobile ? "" : "") +
          "relative p-10 flex flex-col md:flex-row justify-between items-center h-auto py-12"
        }
      >
        {/* Header Section */}
        <div
          className={
            (isMobile ? "mb-7 " : "") +
            "w-full md:w-1/3 flex items-center justify-center"
          }
        >
          <h2 className="text-xl font-bold" style={{ color: textColor }}>
            {headerText}
          </h2>
        </div>

        {/* Text Section */}
        <div className="w-full flex items-center pr-6">
          <p
            className={(isMobile ? "text-center" : "leading-relaxed") + ""}
            style={{ color: textColor }}
          >
            {paragraphText}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImageBox;
